import { call, put } from 'redux-saga/effects';

import {
  createArchitectureRequest,
  deleteArchitectureRequest,
  fetchArchitectureRequest,
} from '../requests';

import { createArchitecture, deleteArchitecture } from '../../../actions';
import { createLocalId } from '../../../utils/local-id';

export function* createArchitectureService(factoryId, data) {
  const localId = yield call(createLocalId);

  yield put(
    createArchitecture({
      factoryId,
      id: localId,
      name: data.file.name,
    }),
  );

  yield call(createArchitectureRequest, factoryId, localId, data);
}

export function* deleteArchitectureService(id) {
  yield put(deleteArchitecture(id));
  yield call(deleteArchitectureRequest, id);
}

export function* fetchArchitectureService(factoryId) {
  yield call(fetchArchitectureRequest, factoryId);
}
